import {
  GET_SITE_LIST_REQUEST,
  GET_SITE_LIST_SUCCESS,
  GET_SITE_LIST_FAILURE,
  GET_SITE_DETAILS_REQUEST,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_FAILURE,
  GET_SITE_FILTER_LIST_REQUEST,
  GET_SITE_FILTER_LIST_FAILURE,
  GET_SITE_FILTER_LIST_SUCCESS,
  CLEAR_SITE_DETAILS,
  GET_SITE_EVENTS_LIST_REQUEST,
  GET_SITE_EVENTS_LIST_SUCCESS,
  GET_SITE_EVENTS_LIST_FAILURE,
  GET_SITE_OPTIMISATION_STRATEGY_REQUEST,
  GET_SITE_OPTIMISATION_STRATEGY_SUCCESS,
  GET_SITE_OPTIMISATION_STRATEGY_FAILURE,
  GET_RESTRICTED_DOCUMENT_LIST_REQUEST,
  GET_RESTRICTED_DOCUMENT_LIST_SUCCESS,
  GET_RESTRICTED_DOCUMENT_LIST_FAILURE,
  PUT_SITE_OPTIMISATION_STRATEGY_REQUEST,
  PUT_SITE_OPTIMISATION_STRATEGY_FAILURE,
  PUT_SITE_OPTIMISATION_STRATEGY_SUCCESS,
  DELETE_RESTRICTED_DOCUMENT_REQUEST,
  DELETE_RESTRICTED_DOCUMENT_SUCCESS,
  DELETE_RESTRICTED_DOCUMENT_FAILURE,
  GET_ENERGY_USAGE_PLAN_REQUEST,
  GET_ENERGY_USAGE_PLAN_SUCCESS,
  GET_ENERGY_USAGE_PLAN_FAILURE,
  GET_ENERGY_USAGE_PLAN_DESCRIPTION_SUCCESS,
  PUT_SITE_REQUEST,
  PUT_SITE_SUCCESS,
  PUT_SITE_FAILURE,
  GET_AMBER_SITE_REQUEST,
  GET_AMBER_SITE_SUCCESS,
  GET_AMBER_SITE_FAILURE,
  CLEAR_AMBER_SITE,
  PUT_AMBER_SITE_REQUEST,
  PUT_AMBER_SITE_FAILURE,
  PUT_AMBER_SITE_SUCCESS,
  PUT_SITE_SALES_CHANNEL_REQUEST,
  PUT_SITE_SALES_CHANNEL_SUCCESS,
  PUT_SITE_SALES_CHANNEL_FAILURE,
  GET_SITE_STATUS_FILTER_LIST_SUCCESS,
  GET_SITE_STATUS_FILTER_LIST_REQUEST,
  GET_SITE_STATUS_FILTER_LIST_FAILURE,
  GET_SITE_STATUS_REQUEST,
  GET_SITE_STATUS_FAILURE,
  GET_SITE_STATUS_SUCCESS,
  CLEAR_SITE_STATUS,
  GET_SITE_DEVICES_REQUEST,
  GET_SITE_DEVICES_SUCCESS,
  GET_SITE_DEVICES_FAILURE,
  CLEAR_SITE_DEVICES,
  GET_SITE_OPERATION_LIST_REQUEST,
  GET_SITE_OPERATION_LIST_SUCCESS,
  GET_SITE_OPERATION_LIST_FAILURE,
} from "actions/site";
import { orderBy } from "lodash";
import { formatPriceExport, getOperationMode } from "utils/unit";

const initialState = {
  loading: false,
  error: {},
  list: [],
  siteOptions: [],
  details: {},
  filteredList: [],
  events: [],
  eventsLoading: false,
  totalCount: 0,
  siteOptimisationStrategyLoading: false,
  siteOptimisationStrategy: {},
  restrictedDocumentList: [],
  restrictedDocumentListLoading: false,
  plan: {
    data: [],
    price_import: 0,
    price_export: 0,
    operation_mode: "",
    operation_description: "",
    operation_information: "",
  },
  planLoading: false,
  amberSite: {},
  amberSiteLoading: false,
  salesChannelLoading: false,
  status: {},
  devices: {},
  devicesLoading: false,
  operationList: [],
  operationLoading: false,
};

export default function site(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SITE_LIST_REQUEST:
    case GET_SITE_DETAILS_REQUEST:
    case GET_SITE_FILTER_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: payload,
        siteOptions: orderBy(payload, ["nmi"]).map((it) => {
          return {
            ...it,
            value: it.id,
            label: it.nmi + " " + it.units?.map((u) => u.serial).join(","),
          };
        }),
      };
    }

    case GET_SITE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        details: payload,
      };
    }

    case GET_SITE_FILTER_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        filteredList: payload.items,
        totalCount: payload?.total_count,
      };
    }

    case GET_SITE_LIST_FAILURE:
    case GET_SITE_DETAILS_FAILURE:
    case GET_SITE_FILTER_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_SITE_DETAILS: {
      return {
        ...state,
        details: {},
      };
    }

    case GET_SITE_EVENTS_LIST_REQUEST: {
      return {
        ...state,
        eventsLoading: true,
      };
    }

    case GET_SITE_EVENTS_LIST_SUCCESS: {
      return {
        ...state,
        eventsLoading: false,
        events: orderBy(payload, ["timestamp"], "desc").map((it, i) => {
          return {
            ...it,
            id: i,
            stopped: it.timestamp,
          };
        }),
      };
    }

    case GET_SITE_EVENTS_LIST_FAILURE: {
      return {
        ...state,
        eventsLoading: false,
      };
    }

    case GET_SITE_OPTIMISATION_STRATEGY_REQUEST:
    case PUT_SITE_OPTIMISATION_STRATEGY_REQUEST: {
      return {
        ...state,
        siteOptimisationStrategyLoading: true,
      };
    }

    case GET_SITE_OPTIMISATION_STRATEGY_SUCCESS: {
      let siteOptimisationStrategy = {};
      if (payload.length > 0) {
        siteOptimisationStrategy = payload[0];
      }
      return {
        ...state,
        siteOptimisationStrategy,
        siteOptimisationStrategyLoading: false,
      };
    }

    case PUT_SITE_OPTIMISATION_STRATEGY_SUCCESS:
    case GET_SITE_OPTIMISATION_STRATEGY_FAILURE:
    case PUT_SITE_OPTIMISATION_STRATEGY_FAILURE: {
      return {
        ...state,
        siteOptimisationStrategyLoading: false,
      };
    }

    case GET_RESTRICTED_DOCUMENT_LIST_REQUEST: {
      return {
        ...state,
        restrictedDocumentListLoading: true,
        restrictedDocumentList: [],
      };
    }

    case GET_RESTRICTED_DOCUMENT_LIST_SUCCESS: {
      return {
        ...state,
        restrictedDocumentListLoading: false,
        restrictedDocumentList: payload.map((item, i) => {
          return {
            ...item,
            id: i,
          };
        }),
      };
    }

    case GET_RESTRICTED_DOCUMENT_LIST_FAILURE: {
      return {
        ...state,
        restrictedDocumentListLoading: false,
        restrictedDocumentList: [],
      };
    }

    case DELETE_RESTRICTED_DOCUMENT_REQUEST: {
      return {
        ...state,
        restrictedDocumentListLoading: true,
      };
    }

    case DELETE_RESTRICTED_DOCUMENT_SUCCESS:
    case DELETE_RESTRICTED_DOCUMENT_FAILURE: {
      return {
        ...state,
        restrictedDocumentListLoading: false,
      };
    }

    case GET_ENERGY_USAGE_PLAN_REQUEST: {
      return {
        ...state,
        planLoading: true,
      };
    }

    case GET_ENERGY_USAGE_PLAN_DESCRIPTION_SUCCESS: {
      return {
        ...state,
        plan: {
          ...state.plan,
          plan_description: payload.plan_description,
        },
      };
    }

    case GET_ENERGY_USAGE_PLAN_SUCCESS: {
      return {
        ...state,
        planLoading: false,
        plan: {
          data: payload.data.map((it) => {
            return {
              ...it,
              price_export: formatPriceExport(it.price_export),
            };
          }),
          price_export: formatPriceExport(payload.price_export),
          price_import: payload.price_import,
          operation_mode: payload.operation_mode,
          operation_description: payload.operation_description,
          operation_information: payload.operation_information,
          plan_description: payload.plan_description,
          dataNextDay: payload.data_next_day.map((it) => {
            return {
              ...it,
              price_export: formatPriceExport(it.price_export),
            };
          }),
        },
      };
    }

    case GET_ENERGY_USAGE_PLAN_FAILURE: {
      return {
        ...state,
        planLoading: false,
      };
    }

    case PUT_SITE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case PUT_SITE_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case PUT_SITE_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case CLEAR_AMBER_SITE: {
      return {
        ...state,
        amberSite: {},
      };
    }

    case GET_AMBER_SITE_REQUEST:
    case PUT_AMBER_SITE_REQUEST: {
      return {
        ...state,
        amberSiteLoading: true,
      };
    }

    case GET_AMBER_SITE_SUCCESS: {
      return {
        ...state,
        amberSiteLoading: false,
        amberSite: payload,
      };
    }

    case PUT_AMBER_SITE_SUCCESS: {
      return {
        ...state,
        amberSiteLoading: false,
      };
    }

    case GET_AMBER_SITE_FAILURE:
    case PUT_AMBER_SITE_FAILURE: {
      return {
        ...state,
        amberSiteLoading: false,
      };
    }

    case PUT_SITE_SALES_CHANNEL_REQUEST: {
      return {
        ...state,
        salesChannelLoading: true,
      };
    }

    case PUT_SITE_SALES_CHANNEL_SUCCESS:
    case PUT_SITE_SALES_CHANNEL_FAILURE: {
      return {
        ...state,
        salesChannelLoading: false,
      };
    }

    case GET_SITE_STATUS_REQUEST: {
      return {
        ...state,
        statusLoading: true,
      };
    }

    case GET_SITE_STATUS_FILTER_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SITE_STATUS_FAILURE: {
      return {
        ...state,
        statusLoading: false,
      };
    }

    case GET_SITE_STATUS_FILTER_LIST_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    case GET_SITE_STATUS_FILTER_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        filteredList: payload.items,
        totalCount: payload?.total_count,
      };
    }

    case GET_SITE_STATUS_SUCCESS: {
      return {
        ...state,
        statusLoading: false,
        status: payload,
        powerflowDetails: {
          ...payload,
          solar: payload?.solar_power,
          hotwater: payload?.hotwater_power,
          battery: payload?.battery_power,
          grid: payload?.grid_power,
          grid_present: payload?.grid_present,
          online: payload?.mqtt_connected,
          soc: payload?.battery_soc,
          ev: payload?.ev1_power,
          ev_status: payload?.ev1_status,
          price_export: formatPriceExport(payload.price_export),
        },
      };
    }

    case GET_SITE_DEVICES_REQUEST: {
      return {
        ...state,
        devicesLoading: true,
      };
    }

    case GET_SITE_DEVICES_SUCCESS: {
      return {
        ...state,
        devicesLoading: false,
        devices: payload,
      };
    }

    case GET_SITE_DEVICES_FAILURE: {
      return {
        ...state,
        devicesLoading: false,
      };
    }

    case GET_SITE_OPERATION_LIST_REQUEST: {
      return {
        ...state,
        operationLoading: true,
      };
    }

    case GET_SITE_OPERATION_LIST_SUCCESS: {
      return {
        ...state,
        operationLoading: false,
        operationList: payload.map((it) => {
          return {
            ...it,
            mode: getOperationMode(it).label,
            description:
              typeof it?.description === "string" ? it?.description : "",
          };
        }),
      };
    }

    case GET_SITE_OPERATION_LIST_FAILURE: {
      return {
        ...state,
        operationLoading: false,
      };
    }

    case CLEAR_SITE_DEVICES: {
      return {
        ...state,
        devices: {},
      };
    }

    case CLEAR_SITE_STATUS: {
      return {
        ...state,
        status: {},
        powerflowDetails: {},
      };
    }

    default:
      return state;
  }
}
